// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import CheckBox from "../../shared/CheckBox";
import TagItem from "../../ratecards/components/TagItem";
import {
  CardListItem,
  CardListItemLabel,
  CardListItemLeft,
  CardListItemRight,
  CardListSubText,
  SubTextAccent,
  Info,
  InfoData,
  InfoLabel,
} from "../../../components/lib/Card";
import LinkButton from "../../../components/lib/LinkButton";
import Inline from "../../../components/lib/Inline";
import classNames from "classnames";

const NegotiationWorksheetListItem = observer(
  class extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    constructor(props) {
      super(props);
      this.handleViewDetail = this.handleViewDetail.bind(this);
      this.deleteTag = this.deleteTag.bind(this);
      this.state = {
        updated: false,
      };
    }

    handleViewDetail() {
      this.context.router.push({
        pathname: `/negotiation-worksheets/${this.props.worksheet.worksheetId}`,
        query: this.context.router.query,
      });
    }

    deleteTag(event: object, tag_id) {
      event.preventDefault();
      event.stopPropagation();
      event.cancelBubble = true;
      event.returnValue = false;

      this.props.store
        .deleteSingleTags({
          tagId: tag_id,
          contentId: this.props.worksheet.worksheetId,
        })
        .then((res) => {
          if (!res.result) return;
          this.props.worksheet.tags.forEach((item, index) => {
            if (item.tagId === tag_id) {
              this.props.worksheet.tags.splice(index, 1);
            }
          });
          this.setState({
            updated: true,
          });
        });
    }

    render() {
      const props = this.props;
      const worksheet = props.worksheet;
      const editing = worksheet.viewState.editing;
      const selected = worksheet.viewState.selected;
      const name = worksheet.worksheetName;
      const country_name = worksheet.country.name;
      const id = worksheet.worksheetId;
      const totalMarkupPercent = !worksheet.totalMarkupPercent
        ? "0%"
        : `${worksheet.totalMarkupPercent}%`;
      const payType = worksheet.payType;

      const tags = worksheet.tags;
      let tagSection = null;
      //console.log('tags', tags);

      const createdDisplay = worksheet.created.format("MMMM D, YYYY");
      let ownerName = "You";
      // let sharedByYou = shared;

      // if (String(rateCard.owner.clientId) !== String(props.store.currentUser.userId)) {
      //   ownerName = rateCard.owner.fullname;
      //   sharedByYou = false;
      // }
      // if (rateCard.owner.email !== localStorage.getItem("PeopleTickerUserEmail")) {
      //   ownerName = worksheet.owner.fullname;
      // }

      let onItemClick = this.props.onClick || this.handleViewDetail;
      let editingSection = null;
      if (editing) {
        onItemClick = worksheet.toggleSelected;
        editingSection = (
          <CheckBox
            type={props.store.allowMultipleItemSelection ? "checkbox" : "radio"}
            name="list-item-select"
            value={name}
            selected={selected}
            style={{ width: 34 }}
            onClick={onItemClick}
          />
        );
      }

      if (tags.length > 0 && !this.props.store.isTagView) {
        tagSection = tags.map((tag) => (
          <TagItem key={tag.tagId} tag={tag} onClick={this.deleteTag} />
        ));
      }

      return (
        <CardListItem selected={selected} onClick={onItemClick}>
          <CardListItemLeft>
            <Inline css={{ gap: 0 }}>
              {editingSection}
              <div>
                <CardListItemLabel>{name}</CardListItemLabel>
                <CardListSubText>
                  Created by <SubTextAccent>{ownerName}</SubTextAccent> on{" "}
                  <SubTextAccent>{createdDisplay}</SubTextAccent>
                </CardListSubText>
              </div>
            </Inline>
            <div className={classNames("tagbox", { "p-left-34": editing })}>
              {tagSection}
            </div>
          </CardListItemLeft>
          <CardListItemRight>
            <Info>
              <InfoLabel>Worksheet Type</InfoLabel>
              <InfoData>{payType}</InfoData>
            </Info>
            <Info css={{ width: "18ch" }}>
              <InfoLabel>Country</InfoLabel>
              <InfoData>{country_name}</InfoData>
            </Info>
            <Info>
              <InfoLabel>Total Markup</InfoLabel>
              <InfoData>{totalMarkupPercent}</InfoData>
            </Info>
            {!editing && (
              <LinkButton to={`/negotiation-worksheets/${id}`}>View</LinkButton>
            )}
          </CardListItemRight>
        </CardListItem>
      );
    }
  }
);

NegotiationWorksheetListItem.propTypes = {
  store: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default NegotiationWorksheetListItem;
